import { styled } from "@mui/material/styles";
import type React from "react";
import { forwardRef } from "react";

const VisuallyHiddenInput = styled("input")({
	clip: "rect(0 0 0 0)",
	clipPath: "inset(50%)",
	height: 1,
	overflow: "hidden",
	position: "absolute",
	bottom: 0,
	left: 0,
	whiteSpace: "nowrap",
	width: 1,
});

const InputHidden = forwardRef<
	HTMLInputElement,
	React.ComponentPropsWithoutRef<"input">
>((props, ref) => {
	return <VisuallyHiddenInput ref={ref} {...props} />;
});

export default InputHidden;
